import React from 'react';
import { LayersIcon, MinusIcon, TagIcon } from 'lucide-react';
import type { CommissionModel } from '../types/payment';
import { commissionModelLabel } from '../utils/paymentConfig';
const styles: Record<CommissionModel, string> = {
  standard: 'border-brand-200 bg-brand-50 text-brand-700',
  flat_fee: 'border-amber-200 bg-amber-50 text-amber-700',
  unsupported: 'border-ink-200 bg-ink-100 text-ink-600'
};
const icons = {
  standard: LayersIcon,
  flat_fee: TagIcon,
  unsupported: MinusIcon
};
export function CommissionModelBadge({
  model
}: {
  model: CommissionModel;
}) {
  const Icon = icons[model];
  return <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold ${styles[model]}`} data-id="element-30" data-mp="3ihbgijztf68q">
      <Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-31" data-mp="3mf94jjhunmaj" />
      {commissionModelLabel[model]}
    </span>;
}